<template>
  <v-card
    class="notification-card d-flex flex-column"
    elevation="2"
    rounded="lg">
    <div class="d-flex align-center justify-space-between px-4 py-3">
      <div class="font-size-16 font-weight-bold">Сповіщення</div>
      <div v-if="notificationList.length">
        <v-btn
          border
          color="white"
          density="compact"
          rounded=""
          size="small"
          @click="notificationReadAll">
          <div class="d-flex align-center ga-1 font-size-11">
            <v-icon>mdi-check</v-icon>
            <span class="font-weight-medium">Прочитати всі</span>
          </div>
        </v-btn>
      </div>
    </div>

    <v-divider></v-divider>

    <div style="min-height: 40px">
      <v-tabs
        v-model="activeTab"
        :show-arrows="false"
        class="notification-tabs px-2"
        color="primary"
        density="compact"
        grow>
        <v-tab
          v-for="tab in tabs"
          :key="tab.value"
          :value="tab.value"
          class="font-size-13 px-3 text-none">
          {{ tab.label }}
          <v-badge
            v-if="tab.value === 'unread' && unreadCount"
            :content="unreadCount"
            color="error"
            inline
            size="x-small"></v-badge>
        </v-tab>
      </v-tabs>
    </div>

    <v-divider></v-divider>

    <v-card-text
      class="notification-card__body pa-0 d-flex flex-column overflow-hidden">
      <div class="notification__container">
        <div
          v-if="
            !filteredNotificationList.length &&
            !$loading.isLoading('getNotificationList')
          "
          class="text-disabled text-center py-8">
          Сповіщення відсутні :)
        </div>

        <div
          v-for="(item, notificationIdx) in filteredNotificationList"
          :id="`notification-${item.id}`"
          :key="item.id"
          @click="navigateToNotification(item)">
          <div
            :class="{ 'notification--unread': item?.statusId !== 2 }"
            class="notification d-flex ga-3 px-3 py-3">
            <v-avatar
              :color="getNotificationAppearance(item).avatarColor"
              size="35">
              <v-icon
                :color="getNotificationAppearance(item).iconColor"
                :icon="getNotificationAppearance(item).icon"
                size="small"></v-icon>
            </v-avatar>

            <div class="d-flex flex-column justify-space-between flex-grow-1">
              <div class="pr-2">
                <span
                  class="font-size-13 d-block font-weight-bold text-primary mb-1">
                  {{ item.notification.entityType.name }}
                </span>
                <div
                  class="font-size-12 text-medium-emphasis"
                  v-html="item.notification.message"></div>
              </div>

              <div class="d-flex align-center mt-1">
                <v-icon
                  color="blue-darken-3"
                  icon="mdi-circle"
                  size="9"></v-icon>
                <span class="font-size-11 text-disabled ml-1">
                  {{
                    new CustomDate(item?.created_at).toString({
                      time: true,
                      format: 'locale-hybrid',
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
          <v-divider
            v-if="filteredNotificationList.length > notificationIdx + 1">
          </v-divider>
        </div>

        <div
          v-if="$loading.isLoading('getNotificationList')"
          class="text-center py-3">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </div>

      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { useNotificationList } from './notificationList'
import { CustomDate } from 'best-modules/utils'
import { onMounted } from 'vue'

export default {
  name: 'NotificationList',
  emits: ['read-all'],
  setup(_, { emit }) {
    const {
      activeTab,
      filteredNotificationList,
      getNotificationList,
      notificationList,
      navigateToNotification,
      notificationReadAll,
      tabs,
      unreadCount,
      getNotificationAppearance,
    } = useNotificationList()

    onMounted(() => {
      getNotificationList()
    })

    const readAll = async () => {
      await notificationReadAll()
      emit('read-all')
    }

    return {
      activeTab,
      filteredNotificationList,
      notificationList,
      navigateToNotification,
      notificationReadAll: readAll,
      tabs,
      unreadCount,
      getNotificationAppearance,
      CustomDate,
    }
  },
}
</script>

<style lang="scss" scoped>
.notification-card {
  height: 510px;
}

.notification-card__body {
  flex: 1 1 auto;
  min-height: 0;
}

.notification {
  cursor: pointer;

  &--unread {
    background: #f0f6fb;
  }

  &:hover {
    background: #f5f6fa;
  }

  &__container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.notification-tabs {
  :deep(.v-slide-group__prev),
  :deep(.v-slide-group__next) {
    display: none !important;
  }

  :deep(.v-slide-group__content) {
    width: 100%;
  }

  :deep(.v-tab) {
    min-width: 0;
    max-width: none;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  :deep(.v-btn__content) {
    white-space: nowrap;
    gap: 4px;
  }
}
</style>
